import { LogoMainHorizontal } from '@/components/brand';
import { ArrowLeft, ArrowRotateLeft, ImportCurve, Send2 } from '@/components/icons';
import { SaveIndicator, type SaveStatus } from '@/components/system/SaveIndicator';
import { Button } from '@/components/ui/button';

interface BuilderTopBarProps {
    canDiscardDraft: boolean;
    isBusy: boolean;
    saveStatus: SaveStatus;
    onBack: () => void;
    onDiscardDraft: () => void;
    onImportGoogleForms: () => void;
    onPublish: () => void;
    onRetrySave: () => void;
}

export function BuilderTopBar({
    canDiscardDraft,
    isBusy,
    saveStatus,
    onBack,
    onDiscardDraft,
    onImportGoogleForms,
    onPublish,
    onRetrySave,
}: BuilderTopBarProps) {
    return (
        <div className="sticky top-0 z-20 -mx-4 -mt-4 mb-6 border-b border-border/70 bg-card px-4 py-3 sm:-mx-8 sm:-mt-8 sm:px-8 lg:-mx-10 lg:px-10">
            <div className="flex w-full flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                <div className="flex min-w-0 items-center gap-3">
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        className="shrink-0"
                        onClick={onBack}
                        aria-label="Voltar para formulários"
                    >
                        <ArrowLeft className="size-4" />
                    </Button>
                    <span className="sr-only">LaudoPsi</span>
                    <div className="shrink-0" aria-hidden="true">
                        <LogoMainHorizontal />
                    </div>
                </div>

                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-4">
                    <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center">
                        {canDiscardDraft ? (
                            <Button
                                type="button"
                                variant="surface"
                                onClick={onDiscardDraft}
                                disabled={isBusy}
                                className="col-span-2 sm:col-span-1"
                            >
                                <ArrowRotateLeft className="size-4" />
                                Descartar
                            </Button>
                        ) : null}
                        <Button
                            type="button"
                            variant="surface"
                            onClick={onImportGoogleForms}
                            disabled={isBusy}
                        >
                            <ImportCurve className="size-4" />
                            Importar
                        </Button>
                        <Button type="button" onClick={onPublish} disabled={isBusy}>
                            <Send2 className="size-4" />
                            Publicar
                        </Button>
                    </div>

                    <div className="flex justify-end">
                        <SaveIndicator status={saveStatus} onRetry={onRetrySave} />
                    </div>
                </div>
            </div>
        </div>
    );
}
